import classNames from 'classnames';

import { sectionElement } from './SectionElement.css';
import type { SectionElementProps } from './SectionElement.types';

export function SectionElement({
  children,
  className = 'bg-white rounded-md',
  title,
  subTitle,
  rightChildren,
  badgeElement,
}: SectionElementProps) {
  return (
    <section className={classNames(sectionElement, className, 'h-auto p-4')}>
      <div className="flex flex-col gap-4">
        {badgeElement}
        <div className="flex items-start justify-between">
          <div className="flex flex-col">
            <h2 className="text-lg font-bold text-gray-900 leading-7">{title}</h2>
            {typeof subTitle === 'string' ? <p className="text-sm text-gray-500 leading-5">{subTitle}</p> : subTitle}
          </div>
          {rightChildren}
        </div>
        {children}
      </div>
    </section>
  );
}
